<template>
<div class="chapter">
<div class="inner_page">
<div class="section level1" id="a-thought">
<h1>A Thought</h1>
<p style="text-indent:0em">Just being around you makes me happy</p>
<p style="text-indent:0em">In your presence I ignore outside distractions</p>
<p style="text-indent:0em">And feel secured and wanted</p>
<p style="text-indent:0em">Let’s face it; you are good company</p>
<p style="text-indent:0em">Around you I laugh</p>
<p style="text-indent:0em">Because we “crack” jokes together</p>
<p style="text-indent:0em">We pretend it’s just a casual pep talk</p>
<p style="text-indent:0em">But watching by our actions,</p>
<p style="text-indent:0em">I know it means more</p>
<p style="text-indent:0em">There is someone in your life, that’s true</p>
<p style="text-indent:0em">But I’ll wait on you endlessly</p>
<p style="text-indent:0em">Cause I wanna be with you</p>
<p style="text-indent:0em">You’ve given me no reasons to back off</p>
<p style="text-indent:0em">So I won’t!</p>
<p style="text-indent:0em">It seems there’s no turning back</p>
<p style="text-indent:0em">So please don’t…!</p><br/>
<p style="text-indent:0em"><strong>Christiana Brontie</strong></p>
<p style="text-indent:0em"><strong><br/>
</strong></p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// ch005.vue?2485dd87